import { BionicNavigation } from '@/assets/js/constants/navigation'
import { defineNuxtRouteMiddleware, useNuxtApp } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to) => {
  const { $filters } = useNuxtApp()

  // manageType will already set its own page title
  if (to.name === 'manage-manageType') return

  const navItem = BionicNavigation.find((item) => {
    return item.link === to.path || item.link === to.fullPath
  })

  const titleParts = ['Backpack', 'Fluency']

  if (navItem) {
    titleParts.unshift(navItem.text)
  } else {
    const paths = to.path
      .split('/')
      .filter((part) => part)
      .map($filters.convertFromCapsKebab)

    if (paths.length) {
      titleParts.unshift(paths[paths.length - 1])
    }
  }

  useHead({ title: titleParts.join(' :: ') })
})
